import { MatSpinner } from '@angular/material/progress-spinner';
import { Component, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { Compagnie, Collaborateur, Partenaire, Site, User } from '../../../shared/model';
import { ActivatedRoute, Router, RouterEvent } from '@angular/router';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { SearchBarComponent } from "../../../shared/components/search-bar-component/search-bar-component";
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PartenaireService } from '../../../shared/services/partenaire-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MatAnchor, MatButton } from "@angular/material/button";
import { MatTooltip } from '@angular/material/tooltip';
import { RangePipe } from '../../../shared/pipes/range-pipe';
import { MatIconModule } from '@angular/material/icon';
import { SiteService } from '../../../site/service/site-service';
import { UpperCasePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SiteComponentModal } from '../../../site/component/site-component/site-component';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { DatabaseConnection } from '../../../shared/services/database-connection';
import { PoliceComponentModal } from '../modal/modal-police';
import { CollaborateurService } from '../../service/collaborateur-service';

export interface ModalDataI{
  title : string
  update ?: boolean
  collaborateur_id ?: string
  data ?: Site
}

@Component({
  selector: 'app-collaborateur-details-component',
  imports: [
    TitleComponent,
    MatTabsModule,
    MatCardModule,
    SearchBarComponent,
    MatIconModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatSpinner,
    MatCheckboxModule,
    MatAnchor,
    MatButton,
    MatTooltip,
    RangePipe,
    ReactiveFormsModule
],
  templateUrl: './collaborateur-details-component.html',
  styleUrl: './collaborateur-details-component.css',
})
export class CollaborateurDetailsComponent {
  collaborateur_id : string = ""
  currentCollaborateur = signal<Collaborateur>(new Collaborateur())
  siteListe = signal<Site[]>([])
  userListe = signal<User[]>([])

  displayedColumns : string[] = [];
  dataSource : MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  @ViewChild('codeInputModal') codeInputModal!: ElementRef;


  loading = false
  searchValue = ""
  API_STORAGE = inject(DatabaseConnection).storageConnection.value
  currentTabName : string = ''
  readonly dialog = inject(MatDialog);
  currentSite = signal<Site>(new Site())

  currentPart : Partenaire = new Partenaire()

  partForm : FormGroup = new FormGroup({})

  format_police = ""
  code_collab = ""
  categorie_format = ""

  showTabs = signal({
    doc : true,
    site : false,
    user : false,
    comp : false
  })

  constructor(
    private route : ActivatedRoute,
    private collaborateurService : CollaborateurService,
    private partenaireService : PartenaireService,
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService,
    private siteService : SiteService,
    private router : Router,
    private fb : FormBuilder
  ){}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.collaborateur_id = res['id']
      this.collaborateurService.get(this.collaborateur_id).subscribe((collaborateur) => this.currentCollaborateur.update((val) => collaborateur))
    })

    this.partForm = this.fb.group({
      code : ['', [Validators.required]],
      categorie : ['', [Validators.required]],
      prefixe : [''],
      separateur : [''],
      anneeDigit : 0,
      codeDigit : 0,
      categorieDigit : 0,
      compteurDigit : 0,
      initiaux : [false]
    })

  }

  ngAfterViewInit() {
    this.currentTabName = (this.tabGroup._tabs.get(this.tabGroup.selectedIndex!)?.textLabel)!;
    this.loadTabView(this.currentTabName!)
  }

  setColorQteState(qte : number, reste : number){
    const tiers = qte/3
    const deuxTiers = (qte*2)/3

    if(reste<=tiers){
      return "state_inactif";
    }else if(reste<=deuxTiers){
      return "state_orange"
    }else{
      return "state_actif"
    }
  }


  loadTabView(currentTabName : string){
    this.dataSource.filter = ""

    switch (currentTabName) {
      case 'Compagnies':
        const comp = {comp : true, site : false, user : false, doc : false}
        this.showTabs.update(val => comp)
        this.compagnieView()
        break;
      case 'Documents':
        const doc = {comp : false, site : false, user : false, doc : true}
        this.showTabs.update(val => doc)
        this.distributionView()
        break;
      /*case 'Sites':
        const site = {comp : false, site : true, user : false, doc : false}
        this.showTabs.update(val => site)
        this.siteView()
        break;
      case 'Utilisateurs':
        const user = {comp : false, site : false, user : true, doc : false}
        this.showTabs.update(val => user)
        this.userView()
        break*/

      default:
        break;
    }
  }



  attestationFormat(rangeValue : string, code : string, type : string){
    const range = rangeValue.split('-')
    return 'de '+code+'*'+type+'*'+range[0].toString().padStart(7, '0')+' à '+code+'*'+type+'*'+range[1].toString().padStart(7, '0')
  }

  compagnieView(){
    this.dataSource = new MatTableDataSource()
    this.displayedColumns = ['id', 'logo', 'compagnie', 'code_partenaire', 'status', 'actions']
    this.loading = true
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.partenaireService.collaborateurPartenaires(this.collaborateur_id).subscribe(
      (res) => {
        this.dataSource.data = res;
        this.loading = false
      },
      (err) => this.loading = false
    )
  }

  distributionView(){
    this.dataSource = new MatTableDataSource()
    this.displayedColumns = ['id', 'compagnie', 'type', 'attestation_range', 'carte_rose_range', 'qte', 'reste']
    this.loading = true
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.collaborateurService.getCollaborateurDistribution(this.collaborateur_id).subscribe(
      (res) => {
        this.dataSource.data = res;
        this.loading = false
      },
      (err) => this.loading = false
    )
  }

  /*siteView(){
    this.displayedColumns = ["id", "collaborateur_name", "name", "owner", "adresse", "status", "actions"]
    this.loading = true
    this.collaborateurService.getCollaborateurSite(this.collaborateur_id).subscribe(
      (res) => {
        this.dataSource.data = res;
        this.loading = false
      },
      (err) => this.loading = false
    )
  }

  userView(){
    this.displayedColumns = ['id','site_name', 'name', 'profil', 'gender', 'adresse', 'status']
    this.loading = true
    this.collaborateurService.getCollaborateurUser(this.collaborateur_id).subscribe(
      (res) => {
        this.dataSource.data = res;
        this.loading = false
      },
      (err) => this.loading = false
    )
  }*/

  onTabChange(event : MatTabChangeEvent){
    //console.log(event.index, ' ', event.tab.textLabel);
    this.currentTabName = event.tab.textLabel
    this.loadTabView(event.tab.textLabel)
  }

  applyFilter(val : string){
    this.searchValue = val
    this.dataSource.filter = val.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

    openPoliceModal(row : Partenaire){
      const dialogRef = this.dialog.open(PoliceComponentModal, {
        width: '800px',
        height : '800px',
        enterAnimationDuration : '500ms',
        exitAnimationDuration : '500ms',
        disableClose : true,
        data : row
      });

      dialogRef.afterClosed().subscribe((res :  {police : string, code : string, categorie : string, join : boolean}) =>{
          if(res!=null){
            this.currentPart.format_police = res.police
            this.currentPart.code_partenaire = res.code
            this.currentPart.categorie = res.categorie
            this.currentPart.join = res.join
            this.confirm()
          }

      })
    }

  checkCode(row : Partenaire){
    console.log(row);

    this.currentPart = row
    this.openPoliceModal(row)
  }

  confirm(){

    const action = this.currentPart.join?'dissocier':'associer'

    this.sweetAlert.confirm('Etez-vous sur de vouloir '+action+' la compagnie '+this.currentPart.compagnie_name+' au coutier '+this.currentPart.collaborateur_name)
    .then((res) =>{
      if(res.isConfirmed){
        this.changePartenaireState(this.currentPart)
      }

      if(res.isDenied){
          const data = this.dataSource.data
          const i = data.findIndex(item => item.id == this.currentPart.id)
          data[i] = res
          this.dataSource.data = data
      }
    })
  }

  changePartenaireState(part : Partenaire){
    this.loading = true

    this.partenaireService.changePartenaireState(part).subscribe({
      next : (res) =>{
        const data = this.dataSource.data
        const i = data.findIndex(item => item.id == part.id)
        data[i] = res
        this.dataSource.data = data
        this.toastr.success("Compagnie "+res.compagnie_name+" à été ajouté ")
        this.loading = false
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue")
        this.loading = false
      }
    })
  }

  /*openAddSiteModal(){
    const data : ModalDataI = {
      title : 'Ajouter un Bureau',
      data : new Site(),
      collaborateur_id : this.collaborateur_id
    }

    const dialogRef = this.dialog.open(SiteComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Site) => {

      if (result?.id != undefined) {
        const data : Site[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("Le bureau "+ result.name + " à été ajouté")
      }
    });
  }*/

  openUpdateSite(collaborateur : Site){
    this.currentSite.set(collaborateur)

    const data : ModalDataI = {
      title : 'Modifier le bureau ' + collaborateur.name,
      update : true,
      data : this.currentSite()
    }

    const dialogRef = this.dialog.open(SiteComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Site) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("Le bureau "+ result.name + " à été modifie")
      }
    });
  }


  confirmDeleteSite(coutier : Site){
    this.sweetAlert
    .confirm('Etez-vous sur de vouloir supprimer le bureau '+ coutier.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.siteService.delete(coutier.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != coutier.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChangeSiteState(site : Site){
    const title = site.disable?'Activation':'Desactivation'
    const action = site.disable?'activer':'desactiver'
    this.sweetAlert.confirm('Etez-vous sur de vouloir '+ action +' le bureau ' + site.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.siteService.changeStatus(site.id).subscribe({
          next : (result) =>{
            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data
            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

  goToSiteDetails(site : Site){
    //console.log('hello');
    this.router.navigateByUrl('/bureaux/'+site.id)
  }
}

